import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { compact } from 'lodash';
/**
 * WordPress dependencies
 */

import { RawHTML } from '@wordpress/element';
export default function save(_ref) {
  let {
    attributes: {
      customText,
      noTeaser
    }
  } = _ref;
  const moreTag = customText ? `<!--more ${customText}-->` : '<!--more-->';
  const noTeaserTag = noTeaser ? '<!--noteaser-->' : '';
  return createElement(RawHTML, null, compact([moreTag, noTeaserTag]).join('\n'));
}
//# sourceMappingURL=save.js.map